import sharedConstants from "shared/imports/sharedConstants"

module.exports = {
    BULK_EMAIL_REPORT_ID_PLACEHOLDER: "BULK_EMAIL_IDS",

    // for screen responsiveness
    MOST_FREQUENT_WINDOW_WIDTH: 1440,
    SECOND_FREQUENT_WINDOW_WIDTH: 1366,
    ...sharedConstants,
}
